// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { MenuItem } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import i18n from '../../../i18n';
import AssignSettingDialog from '../../dialogs/AssignSettingDialog';
import { Archive, AssignmentInd } from '@mui/icons-material';
import { AppDataContext } from '../../../context/Context';
import React from 'react';

export default class GatewaySettingsPage extends GridPageAbstract {
    static contextType = AppDataContext;
    constructor(props) {
        super(props);
        this.Name = 'publicGatewaySettings';
        this.Server =
            this.props.context.getState().server.publicGatewaySettings;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['templateName', 'gatewayApi.name'];
        this.showDatePicker = false;
        this.hasCustomLogicOnMount = true;

        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                {
                    id: 'templateName',
                    label: 'templateName',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'settingsJson',
                    label: 'settingsJson',
                    alignRight: false,
                    cell: 'Text',
                    disableEditor: true,
                    displayDialogDetails: true,
                    details: 'Json'
                },
                {
                    id: 'gatewayApiId',
                    label: 'gatewayApi',
                    alignRight: false,
                    cell: 'Select',
                    show: 'name',
                    object: 'gatewayApi',
                    from: 'publicGatewayApis',
                    displayGrid: true
                },
                {
                    id: 'modifiedReason',
                    label: 'modifiedReason',
                    alignRight: false,
                    cell: 'BigText',
                    displayGrid: true,
                    disableEditor: true
                },
                {
                    id: 'modifiedBy',
                    label: 'modifiedBy',
                    alignRight: false,
                    cell: 'Select',
                    object: 'modifiedBy',
                    show: 'firstName+lastName',
                    displayGrid: true,
                    disableEditor: true,
                    customSort: 'modifiedBy.firstName'
                }
            ];
        this.state = {
            ...this.state,
            head: this.Head,
            openAssignDialog: false,
            gatewaySettingsId: null
        };
    }
    customLogicOnMount() {
        this.fs.clearGroup('prefilterBase')
            .addFilter('isArchived', '!=', true, 'prefilterBase', true);
    }

    is2faEnabled = () => {
        const userInfo = this.context.getState().userInfo;
        return userInfo && userInfo.twoFactorEnabled;
    };
    handleOpenAssign = (event) => {
        const itemId = this.state.menuClickItemId;
        const is2faEnabled = this.is2faEnabled();
        if (is2faEnabled) {
            this.setState({
                openAssignDialog: true,
                gatewaySettingsId: itemId
            });
            this.handleCloseMenu();
        } else {
            const errorMessage = i18n.t('text.2faRequired');
            this.handleError({ error: errorMessage });
            this.handleCloseMenu();
        }
    };
    handleCloseAssignDialog = () => {
        this.setState({
            openAssignDialog: false,
            gatewaySettingsId: null
        });
    };
    handleSaveAssignDialog = () => {
        this.setState({
            openAssignDialog: false,
            gatewaySettingsId: null
        });
        this.retrieveData();
    };


    renderCustomMenuItems() {
        const canAssign = this.allowedAction('assign-gateway-settings');

        const isItemArchived = this.getMenuClickItemValue('isArchived') === true;

        const isAllowedArchive = this.allowedArchive() && !isItemArchived;

        return [
            <MenuItem
                key="showDetails"
                onClick={(event) => this.handleShowDialogDetails(event)}
            >
                <InfoIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.showDetails')}
            </MenuItem>,
            canAssign && (
                <MenuItem
                    key="assign"
                    onClick={(event) => this.handleOpenAssign(event)}
                >
                    <AssignmentInd sx={{ mr: 2, width: '20px' }} />
                    {i18n.t('common.assignGatewaySettings')}
                </MenuItem>
            ),
            isAllowedArchive && (
                <MenuItem
                    key="archive"
                    onClick={() => this.handleArchiveConfirmDialogOpen()}
                >
                    <Archive sx={{ mr: 2, width: '20px' }} />
                    {i18n.t('common.archive')}
                </MenuItem>
            )
        ];
    }
    renderCustom() {
        const itemId = this.state.gatewaySettingsId;
        return (
            <div>
                {this.state.openAssignDialog && (
                    <AssignSettingDialog
                        id={itemId}
                        open={this.state.openAssignDialog}
                        onClose={this.handleCloseAssignDialog}
                        onSave={this.handleSaveAssignDialog}
                        server={this.Server}
                    />
                )}
            </div>
        );
    }
}
